import React from 'react';
import { formatNumber } from '../../../common/utils';
var HistogramBar = function (_a) {
    var total = _a.total, value = _a.value, barsCnt = _a.barsCnt, maxYValue = _a.maxYValue, onHover = _a.onHover;
    var percent = value / total * 100;
    var height = percent / maxYValue * 100;
    return (React.createElement("div", { className: "histogramBar", style: { width: 100 / barsCnt + "%" }, onMouseEnter: onHover },
        React.createElement("div", { className: "histogramBar__rectangle", style: {
                height: height + "%"
            } },
            React.createElement("div", { className: "histogramBar__labelWrapper" },
                React.createElement("span", { className: "histogramBar__value" },
                    formatNumber(value),
                    " "),
                React.createElement("span", { className: "histogramBar__percentage" },
                    percent.toFixed(1),
                    "%")))));
};
export default HistogramBar;
//# sourceMappingURL=HistogramBar.js.map